import React from 'react';
import classnames from 'classnames';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';

import Typography from '@/components/Typography';
import { SidebarConsumer } from '@/components/Context/Sidebar';

import Link from '@/components/Link';

export interface Props {
  icon: LucideIcon | null;
  url: string;
  className?: string;
  external?: boolean;
}

const NavigationItem: React.FC<Props & RouteComponentProps> = ({ icon: Icon, url, className, children, location }) => {
  const isActive = location.pathname.indexOf(url) === 0;

  return (
    <SidebarConsumer>
      {({ close }) => (
        <Link
          to={url}
          className={classnames(
            'border-solid border-b-2 border-transparent hover:border-primary text-gray-900 inline-flex items-center px-2 pt-1 text-sm font-medium ',
            className
          )}
          activeClassName="border-yellow-500 text-gray-900"
          onClick={close}
        >
          <Icon />

          <Typography is="div" size="sm" className="pl-2 text-gray-900 hover:text-gray-700">
            {children}
          </Typography>
        </Link>
      )}
    </SidebarConsumer>
  );
};

export default withRouter(NavigationItem);
